import apiClient from '@/services/axios'

export async function post(dto) {
  var response = await apiClient.post(process.env.VUE_APP_CRM_API_BASE_URL + '/EngageEmail/Status', dto)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update status')
}